import { MdDialog, MdDialogConfig, MdDialogRef } from '@angular/material';
import { Component, OnInit, ViewContainerRef } from '@angular/core';

import { ApplicationActivity, TimeKeepingActivity } from 'app/admin/applicationactivity/application-activity.model';
import { ApplicationActivityService } from 'app/admin/applicationactivity/application-activity.service';
import {
    SaveApplicationActivityComponent
} from 'app/admin/applicationactivity/saveapplicationactivity/save-application-activity.component';
import { SnackBarService } from 'app/services/snackbar.service';
import { MessageService } from 'app/services/messages.service';

@Component({
    selector: 'application-activity',
    templateUrl: './application-activity.component.html'
})
export class ApplicationActivityComponent implements OnInit {
    applicationActivities: ApplicationActivity;
    dialogRef: MdDialogRef<any>;

    constructor(
        private applicationActivityService: ApplicationActivityService,
        private viewContainerRef: ViewContainerRef,
        public dialog: MdDialog,
        private snackBarService: SnackBarService) {
    }

    ngOnInit() {
        this.loadApplicationActivities();
    }

    loadApplicationActivities() {
        this.applicationActivityService.getApplicationActivities().subscribe(response => {
            this.applicationActivities = response;
        });
    }

    getStandardActivities() {
        if (this.applicationActivities) {
            return this.applicationActivities.standardActivities;
        }
        return [];
    }

    getTenantActivities() {
        if (this.applicationActivities) {
            return this.applicationActivities.tenantActivities;
        }
        return [];
    }

    openSaveApplicationActivity(tenantActivity: TimeKeepingActivity, action: string) {
        const config = new MdDialogConfig();
        config.disableClose = true;
        config.viewContainerRef = this.viewContainerRef;

        this.dialogRef = this.dialog.open(SaveApplicationActivityComponent, config);
        this.dialogRef.componentInstance.action = action;
        this.dialogRef.componentInstance.activityDetails = tenantActivity;
        this.dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.loadApplicationActivities();
            }
        });
    }

    openStandardApplicationActivity(standardApplicationActivity: string, action: string) {
        const config = new MdDialogConfig();
        config.disableClose = true;
        config.viewContainerRef = this.viewContainerRef;

        this.dialogRef = this.dialog.open(SaveApplicationActivityComponent, config);
        this.dialogRef.componentInstance.action = action;
        this.dialogRef.componentInstance.standardActivity = standardApplicationActivity;
        this.dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.loadApplicationActivities();
            }
        });
    }

    deleteTimeKeepingActivity(tenantActivity: TimeKeepingActivity) {
        this.applicationActivityService.deleteApplicationActivity(tenantActivity.id)
            .subscribe(response => {
                this.callSnackBarService(response);
            }, err => {
                this.callSnackBarService(err);
            });
    }

    callSnackBarService(response: any) {
        this.snackBarService
            .showStatus(response,
            MessageService.DELETE_APPLICATION_ACTIVITY_SUCCESS,
            MessageService.APPLICATION_ACTIVITY_FAILURE);
    }
}



// WEBPACK FOOTER //
// ./src/app/admin/applicationactivity/application-activity.component.ts